import DropdownFilter, { IDropdownFilterProps } from './DropdownFilter'
import { formatEnum } from '@cbgms/base/utils/helpers'

type EnumFilterProps = Omit<IDropdownFilterProps, 'options'>

const toEnumFilter = (enumName: string, enumValues: string[]) => {
  const options = enumValues
    ? enumValues.map(value => ({
        text: formatEnum(enumName.replace('SliceOfEnum', 'Enum'), value),
        value
      }))
    : []

  const EnumFilter = (props: EnumFilterProps) => {
    return <DropdownFilter {...props} options={options} />
  }
  return EnumFilter
}

export default toEnumFilter
